module.exports = __webpack_public_path__ + "img/ring_r_i_1_null@2x.5e10afb0.png";